export const AGENDAMENTO_FORM_FIELD_KEYS = ['nome', 'cpf', 'whatsapp', 'email', 'dataAgendamento', 'horario']



export function defaultAgendamentoFieldConfig () {

  return {

    nome: { enabled: true, optional: false },

    cpf: { enabled: true, optional: true },

    whatsapp: { enabled: true, optional: false },

    email: { enabled: true, optional: true },

    dataAgendamento: { enabled: true, optional: false },

    horario: { enabled: true, optional: false }

  }

}



export function normalizeAgendamentoFieldConfig (raw) {

  const base = defaultAgendamentoFieldConfig()

  const out = { ...base }

  for (const key of AGENDAMENTO_FORM_FIELD_KEYS) {

    const src = raw?.[key] || {}

    out[key] = {

      enabled: ['nome', 'dataAgendamento', 'horario'].includes(key) ? true : !!src.enabled,

      optional: ['nome', 'dataAgendamento', 'horario'].includes(key) ? false : !!src.optional

    }

  }

  if (!out.whatsapp.enabled && !out.email.enabled) {

    out.whatsapp.enabled = true

  }

  return out

}



export function canDisableAgendamentoField (config, key) {

  if (['nome', 'dataAgendamento', 'horario'].includes(key)) return false

  if (key !== 'email' && key !== 'whatsapp') return true

  const other = key === 'email' ? 'whatsapp' : 'email'

  return config[other]?.enabled === true

}



export function publicAgendamentoFormUrl (token) {

  const origin = typeof window !== 'undefined' ? window.location.origin : ''

  return `${origin}/agendamento/${token}`

}



export function agendamentoIframeSnippet (token) {

  const url = publicAgendamentoFormUrl(token)

  return `<iframe src="${url}" width="100%" height="720" frameborder="0" title="Formulário de agendamento"></iframe>`

}

